import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ProjectCard from './ProjectCard';
import { FILTER_PROJECTS } from './redux/reducers';

const Projects = () => {
  const projects = useSelector((state) => state.filteredProjects);
  const dispatch = useDispatch();

  const handleSearch = (e) => {
    dispatch({
      type: FILTER_PROJECTS,
      payload: e.target.value
    });
  };

  return (
    <div className="page-container projects-page">
      <h2>My Projects</h2>
      <div className="search-container">
        <input
          type="text"
          placeholder="Filter projects by name..."
          onChange={handleSearch}
          className="search-input"
        />
      </div>
      <div className="projects-grid">
        {projects.length > 0 ? (
          projects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))
        ) : (
          <p>No projects found.</p>
        )}
      </div>
    </div>
  );
};

export default Projects;